module.exports = __webpack_public_path__ + "img/001.dd2b7b0f.jpg";